import { type CSSProperties, type FC, type MouseEventHandler } from 'react'
import classNames from 'classnames'
import { Button } from '../../../Button/Button'

interface AddItemLinkProps {
  noun: string
  disabled?: boolean
  onClick?: MouseEventHandler<HTMLButtonElement>
  className?: string
  style?: CSSProperties
}

export const AddItemLink: FC<AddItemLinkProps> = ({ noun, disabled, onClick, className, style }) => (
  <Button
    type='button'
    variant='primaryLinkButton'
    className={classNames('p-0 align-self-start button-medium border-0 text-decoration-none', className)}
    style={style}
    disabled={disabled}
    onClick={onClick}
  >
    <span aria-hidden='true'>+ </span>Add {noun}
  </Button>
)
